import { z } from 'zod'

const AcfTaxonomyObjectSchema = z.object({
  term_id: z.number(),
  name: z.string(),
  slug: z.string(),
})

const AmicusSchema = z.object({
  link: z.string(),
  title: z.object({ rendered: z.string() }),
  id: z.number(),
  acf: z.object({
    case_number: z.union([z.string(), z.number()]).optional(),
    case_year: z.union([z.string(), z.number()]).optional(),
    coamicus_parties: z.string().optional(),
    amicus_counsel: z.string().optional(),
    case_forum: z.string().optional(),
    facts: z.string().optional(),
    decision: z.string().optional(),
    summary: z.string().optional(),
    requested: z.string().optional(),
    case_issues: z.array(z.object({ issue: z.string() })).or(z.literal(false)),
    keywords: z
      .array(AcfTaxonomyObjectSchema)
      .transform((keywords) => keywords.map((keyword) => keyword.name))
      .nullish(),
    case_amicus_brief_link: z.string().optional(),
    case_amicus_decision_link: z.string().optional(),
    case_opinion_link: z.string().optional(),
  }),
})

export const AmicusArraySchema = z.array(AmicusSchema)

export type AmicusBrief = z.infer<typeof AmicusSchema>
